import React from 'react'
import { Text } from '@afterpaytouch/core'
import { OrderSource } from '@afterpaytouch/portal-api'
import { useTranslation } from '../../../../../utils/convergence'
import { useCheckoutSizes } from '../../../../../utils/responsive'
import styles from './style.module.css'
import { useOrderSource } from '../../../../../state'

export const ChargeAtShipMessage = (): JSX.Element | null => {
  const { t } = useTranslation()
  const { textSize } = useCheckoutSizes()
  const orderSource = useOrderSource()

  if (orderSource === OrderSource.APPLE_RETAIL_IN_STORE) {
    return null
  }

  return (
    <div className={styles.container}>
      <Text size={textSize} color='Gray50' testNameSpace='charge-at-ship-message'>
        {t('summary:chargeAtShipMessage')}
      </Text>
    </div>
  )
}
